/**
 * Public copy and HTTP shapes for self-serve sign-in link on /login.
 * @see docs/adr/0002-administrator-issued-sign-in-links.md (Amendment 2026-06)
 */
import type { SignInLinkAdminErrorCode } from '@/lib/sign-in-link-admin-service';

export const SELF_SERVE_GENERIC_FAILURE_MESSAGE =
  'If you have access to Harry, check your inbox for a sign-in link. If nothing arrives, contact your administrator.';

export const SELF_SERVE_SUCCESS_MESSAGE =
  'Check your inbox for a sign-in link.';

/** Policy outcomes that must not reveal invite/offboard/cooldown state to clients. */
export const SELF_SERVE_OPAQUE_POLICY_CODES: SignInLinkAdminErrorCode[] = [
  'NOT_INVITED',
  'OFFBOARDED',
  'COOLDOWN',
  'INVALID_NONCE',
];

export function isSelfServeOpaquePolicyError(code: string): boolean {
  return (SELF_SERVE_OPAQUE_POLICY_CODES as string[]).includes(code);
}

// F-15 (2026-07-31 pentest): the previous 403 opaque-policy response builder was
// removed. Distinct statuses/bodies made invited-email enumeration trivial; routes now
// answer policy rejections with the same 200 body shape as success (uniform response).
